<template>
  <div class="form-header">
    <div class="form-header-innner">
      <a-button
        class="form-back-btn"
        @click="back"
      >
        返回
      </a-button>
      <div class="form-name">
        <span v-show="isEdit">
          <input
            ref="editInput"
            v-model="name"
            placeholder="这里是邮件名称，点击可修改"
            @blur="setEdit"
            @keyup.enter="setEdit"
          >
        </span>
        <span v-show="!isEdit">
          <em>{{ name }}</em>
          <i
            class="iconfont iconicon-test66"
            @click="getEdit"
          />
        </span>
      </div>
      <!-- :disabled="saveDisabled" -->
      <a-dropdown>
        <a-button
          type="primary"
          class="ant-dropdown-link send-btn"
          @click="handleSave('deal', sendBtnName)"
        >
          {{ sendBtnName }} <i class="iconfont iconicon-test69" />
          <!-- 保存 排期 发送 -->
        </a-button>
        <a-menu slot="overlay">
          <a-menu-item v-if="!emailid || status === -1">
            <a @click="handleSave('draft')">
              存草稿
            </a>
          </a-menu-item>
          <a-menu-item @click="handleSave('priview')">
            <router-link
              :to="{name: 'EdmEmailPrivew', query: {
                emailid: emailid,
                priview: 1
              }}"
              target="_blank"
            >
              预览
            </router-link>
          </a-menu-item>
          <a-menu-item @click="handleSave('test')">
            测试
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    emailName: {
      type: [String, Number],
      default: ''
    },
    emailid: {
      type: [String, Number],
      default: ''
    },
    auto: {
      type: [String, Number, Boolean],
      default: 0
    },
    sendnow: {
      type: [String, Number],
      default: 0
    },
    status: {
      type: [String, Number],
      default: 1
    }
    /* saveDisabled: {
      type: Boolean,
      default: false
    }, */
  },
  data () {
    return {
      name: '',
      isEdit: false,
      sendBtnName: ''
    }
  },

  computed: {
    ...mapState('edm/editEmail', ['emailInfo'])
  },

  watch: {
    emailName (val) {
      if (val) {
        this.name = val
      }
    },
    auto: {
      handler (val) {
        this.setSendBtnName()
      },
      immediate: true
    },
    sendnow (val) {
      this.setSendBtnName()
    }
  },

  mounted () {
    this.name = this.emailName
  },

  methods: {
    getEdit () {
      this.isEdit = !this.isEdit
      this.$nextTick(() => {
        this.$refs.editInput.focus()
      })
    },
    setEdit () {
      this.isEdit = false
    },
    setSendBtnName () {
      let { config = {} } = this.emailInfo || {}
      let { auto, sendnow } = config || {}
      if (auto) {
        this.sendBtnName = '保存'
      } else if (sendnow === 0) {
        this.sendBtnName = '排期'
      } else {
        this.sendBtnName = '发送'
      }
    },
    handleSave (type, sendBtnName) {
      this.$emit('save', type, sendBtnName)
      this.$emit('getName', this.name)
    },
    back () {
      this.$emit('back')
    }
  }
}
</script>
<style lang="scss" scoped>
.form-header {
  width: 100%;
  height: 56px;
  background: #fff;
  .form-header-innner {
    // height: 32px;
    padding: 12px 0;
    max-width: 1280px;
    margin: 0 auto;
    line-height: 32px;
    position: relative;
    text-align: center;
    .sub-form-btn {
      position: absolute;
      right: 0;
      top: 12px;
    }
    .form-back-btn {
      position: absolute;
      left: 0;
      top: 12px;
    }
    .form-name {
      display: inline;
      .iconicon-test66 {
        color: #ebebeb;
        font-size: 18px;
        margin-left: 10px;
        cursor: pointer;
      }
      input {
        border: 0 none;
        width: 234px;
        text-align: center;
        outline: none;
      }
      input::-webkit-input-placeholder {
        /*WebKit browsers*/

        color: #d8d8d8;
      }

      input::-moz-input-placeholder {
        /*Mozilla Firefox*/

        color: #d8d8d8;
      }

      input::-ms-input-placeholder {
        /*Internet Explorer*/

        color: #d8d8d8;
      }
      em {
        font-style: normal;
      }
    }
  }
  .send-btn {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 14px;
    color: #fff;
    .iconfont {
      margin-left: 5px;
    }
  }
}
</style>
